import { useEffect, useState } from "react";
import { http, formatErr } from "../../lib/api";
import { usePolling } from "../../lib/usePolling";
import { olabel } from "../../lib/labels";
import { toast } from "sonner";
import { Upload } from "lucide-react";

export default function AgentPagamenti() {
  const [list, setList] = useState(null);
  const [blocked, setBlocked] = useState(false);
  const [open, setOpen] = useState(null);
  const [rec, setRec] = useState({ amount: "", reference: "", date: "" });

  const load = async () => {
    try { const { data } = await http.get("/crm/me/obligations"); setList(data); setBlocked(false); }
    catch (e) { if (e?.response?.status === 403) { setBlocked(true); setList([]); } else toast.error(formatErr(e)); }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  usePolling(load, { interval: 10000, enabled: !blocked });

  const upload = async (e) => {
    e.preventDefault();
    const amount = parseFloat(rec.amount);
    if (!amount || amount <= 0) return toast.error("Importo non valido.");
    try {
      await http.post(`/crm/me/obligations/${open}/receipts`, { amount, reference: rec.reference, date: rec.date || null });
      setRec({ amount: "", reference: "", date: "" }); setOpen(null); await load(); toast.success("Contabile caricata.");
    } catch (err) { toast.error(formatErr(err)); }
  };

  if (blocked) return <div data-testid="agent-pagamenti-blocked" className="max-w-2xl mx-auto card-clean p-6 text-center"><h1 className="font-serif text-2xl mb-2">Pagamenti</h1><p className="text-sm text-neutral-600">Disponibili dopo l'attivazione del tuo account.</p></div>;
  if (list === null) return <div className="p-6 text-sm text-neutral-500">Caricamento…</div>;

  return (
    <div data-testid="agent-pagamenti-page" className="max-w-4xl mx-auto">
      <h1 className="font-serif text-3xl mb-5">Pagamenti e contabili</h1>
      <div className="card-clean overflow-hidden" data-testid="agent-oblig-list">
        {list.length === 0 ? <div className="p-6 text-sm text-neutral-500">Nessun pagamento previsto assegnato.</div> : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] uppercase tracking-widest text-neutral-500 border-b" style={{ borderColor: "var(--border-silver)" }}><th className="px-4 py-3">Tipo</th><th className="px-4 py-3">Salone</th><th className="px-4 py-3">Totale</th><th className="px-4 py-3">Stato</th><th className="px-4 py-3">Contabile</th></tr></thead>
            <tbody>
              {list.map((o) => (
                <tr key={o.id} className="border-b last:border-0" style={{ borderColor: "var(--border-silver)" }} data-testid={`agent-oblig-row-${o.id}`}>
                  <td className="px-4 py-3">{olabel(o.type)}</td><td className="px-4 py-3 text-neutral-500">{o.salon_name || "—"}</td>
                  <td className="px-4 py-3">€ {o.amount_total}</td><td className="px-4 py-3">{o.status}</td>
                  <td className="px-4 py-3"><button onClick={() => setOpen(open === o.id ? null : o.id)} data-testid={`agent-oblig-upload-${o.id}`} className="px-2 py-1 rounded border text-xs flex items-center gap-1" style={{ borderColor: "var(--border-silver)" }}><Upload className="w-3 h-3" /> Carica</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {open && (
        <form onSubmit={upload} className="card-clean p-5 mt-5 grid grid-cols-1 md:grid-cols-3 gap-3 text-sm" data-testid="agent-receipt-form">
          <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Importo (€)</span><input type="number" step="0.01" value={rec.amount} onChange={(e) => setRec({ ...rec, amount: e.target.value })} data-testid="ar-amount" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
          <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Riferimento bonifico</span><input value={rec.reference} onChange={(e) => setRec({ ...rec, reference: e.target.value })} data-testid="ar-ref" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
          <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Data</span><input type="date" value={rec.date} onChange={(e) => setRec({ ...rec, date: e.target.value })} data-testid="ar-date" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
          <div className="md:col-span-3"><button type="submit" data-testid="agent-receipt-save" className="px-4 py-2 rounded-md text-white text-sm" style={{ background: "var(--brand-dark)" }}>Invia contabile</button></div>
        </form>
      )}
    </div>
  );
}
